import type { InjectionKey, Ref } from 'vue'
import type { Message } from '@/types'

export const messageKey = Symbol('messages') as InjectionKey<Ref<Message[]>>
export const chatRoundEndKey = Symbol('chatRoundEnd') as InjectionKey<Ref<boolean>>
export const isSingleChatKey = Symbol('isPreviewChat') as InjectionKey<Ref<boolean>>
export const sekaiAudioPlayingKey = Symbol('sekaiAudioPlayingKey') as InjectionKey<Ref<boolean>>
export const streamCompleteKey = Symbol('streamCompleteKey') as InjectionKey<Ref<boolean>>
export const originalTextKey = Symbol('originalTextKey') as InjectionKey<Ref<string | undefined>>
export const lastMessagePositionKey = Symbol('lastMessagePositionKey') as InjectionKey<Ref<number | undefined>>
export const autoPlayKey = Symbol('autoPlayKey') as InjectionKey<Ref<boolean>>
